import { useEffect } from 'react';
import { onSocketEvent, offSocketEvent } from '../services/SocketService';
import { toaster } from '../utils/toast';

const SW_NOTIFICATION_EVENTS = [
  'silentWitnessRequested',
  'silentWitnessComplete',
  'silentWitnessFailed',
  'silentWitnessReportComplete',
  'silentWitnessReportFailed'
];

// listens for SW pipeline socket events at the case-page level so toasts surface
// even after the user closes the SW modal (where the work was kicked off)
const useSilentWitnessNotifications = () => {
  useEffect(() => {
    const handleNotification = ({ success, message }) => {
      toaster({ message, success });
    };
    SW_NOTIFICATION_EVENTS.forEach((eventName) => {
      onSocketEvent(eventName, handleNotification);
    });
    return () => {
      SW_NOTIFICATION_EVENTS.forEach((eventName) => {
        offSocketEvent(eventName, handleNotification);
      });
    };
  }, []);
};

export default useSilentWitnessNotifications;
